// src/components/ui/Empty.js
import React from 'react';

const Empty = ({ icon: I, title, desc, action }) => (
  <div className="text-center py-16">
    <div className="w-16 h-16 rounded-full bg-gray-100 dark:bg-gray-800 flex items-center justify-center mx-auto mb-4">
      <I size={28} className="text-gray-400" />
    </div>
    <h3 className="text-lg font-bold mb-2 dark:text-gray-100">{title}</h3>
    <p className="text-gray-500 dark:text-gray-400 mb-4">{desc}</p>
    {action}
  </div>
);

export default Empty;
